//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import Tags from 'src/components/TagManagement';
import { dialog } from 'src/boot/mixins.js';
export default {
  mixins: [dialog],
  components: {
    Tags: Tags,
    TeDialog: TeDialog
  },
  props: {
    selection: {
      type: Boolean,
      default: false
    },
    selectedItems: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    editable: {
      type: Boolean,
      default: true
    },
    integrationProjectId: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      internalSelectedItems: this.selectedItems
    };
  },
  methods: {
    confirmSelection: function confirmSelection() {
      this.onOKClick(this.internalSelectedItems);
    }
  }
};